export const Host = {
    Web: 'Web',
    Teams: 'Teams',
    Canvas: 'Canvas',
    Unknown: '',
};
export default Host;
